import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { queryProviders } from '../../util/api';
import { denormalisedResponseEntities } from '../../util/data';

// ================ Async Thunks ================ //

const queryProvidersPayloadCreator = ({ page = 1, sortOrder = 'asc' } = {}, thunkAPI) => {
  return queryProviders(page, 12, sortOrder).then(response => {
    // Denormalize the response to join relationships (e.g., profileImage)
    const providers = denormalisedResponseEntities(response);
    return {
      providers,
      meta: response.data.meta,
    };
  });
};

export const queryProvidersAction = createAsyncThunk(
  'FarmSearchPage/queryProviders',
  queryProvidersPayloadCreator
);

// ================ Slice ================ //

const initialState = {
  providers: [],
  queryProvidersInProgress: false,
  queryProvidersError: null,
  pagination: null,
};

const farmSearchPageSlice = createSlice({
  name: 'FarmSearchPage',
  initialState,
  reducers: {
    queryProvidersRequest(state) {
      state.queryProvidersInProgress = true;
      state.queryProvidersError = null;
    },
    queryProvidersSuccess(state, action) {
      state.providers = action.payload.providers;
      state.pagination = action.payload.meta;
      state.queryProvidersInProgress = false;
    },
    queryProvidersError(state, action) {
      state.queryProvidersInProgress = false;
      state.queryProvidersError = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(queryProvidersAction.pending, state => {
        state.queryProvidersInProgress = true;
        state.queryProvidersError = null;
      })
      .addCase(queryProvidersAction.fulfilled, (state, action) => {
        state.providers = action.payload.providers;
        state.pagination = action.payload.meta;
        state.queryProvidersInProgress = false;
      })
      .addCase(queryProvidersAction.rejected, (state, action) => {
        state.queryProvidersInProgress = false;
        state.queryProvidersError = storableError(action.payload);
      });
  },
});

export const { queryProvidersRequest, queryProvidersSuccess, queryProvidersError } =
  farmSearchPageSlice.actions;

export default farmSearchPageSlice.reducer;

// ================ loadData function ================ //

export const loadData = (params, search, config) => dispatch => {
  const queryParams = new URLSearchParams(search);
  const page = parseInt(queryParams.get('page'), 10) || 1;
  return dispatch(queryProvidersAction(page));
};
